import type { AliasTokens, SemanticSurface } from '@/theme/types'

export const createSemanticSurface = (alias: AliasTokens): SemanticSurface => ({
  surface: alias.brandSurface,
  surfaceElevated: alias.brandSurface,
  surfaceOverlay: alias.brandBackground,
})

